import 'bootstrap/dist/css/bootstrap.css';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { initialAppState } from './store';

// MSAL imports
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  PublicClientApplication,
} from '@azure/msal-browser';
import { getRequestOptions } from './utils/utils';
import { setMsalInstance } from './components/SSO/msalInstance';
import { IdentityManagerType } from './Interfaces/SSO/IdentityManagerConfiguration';

// Create browser history to use in the Redux store
const baseUrl = document
  .getElementsByTagName('base')[0]
  .getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, pre-populating with state from the server where available.
const { store, persistor } = configureStore(history, initialAppState);

const fetchIdentityManagerConfiguration = async (): Promise<any> => {
  var getIdentityManagerConfiguration = await fetch(
    'auth/getIdentityManagerConfiguration',
    getRequestOptions(undefined)
  )
    .then(response => {
      if (response.ok) {
        return response.json();
      }
    })
    .then(data => {
      return data;
    })
    .catch(error => {
      return undefined;
    });
  return getIdentityManagerConfiguration;
};

fetchIdentityManagerConfiguration().then((Config: any) => {
  let msalInstance: PublicClientApplication | undefined;

  let identityMgrType = IdentityManagerType.Fake;
  if (!Config || Config.IdentityManagerType === 0 || Config.IdentityManagerType === IdentityManagerType.ActiveDirectory) {
    ReactDOM.render(
      <Provider store={store}>
        <PersistGate loading={undefined} persistor={persistor}>
          <ConnectedRouter history={history}>
            <App identityMgrType={identityMgrType} />
          </ConnectedRouter>
        </PersistGate>
      </Provider>,
      document.getElementById('root')
    );
  } else {
    identityMgrType = Config.IdentityManagerType;
    if (Config.IdentityManagerType === IdentityManagerType.Msal) {
      msalInstance = new PublicClientApplication(
        Config.Configuration
      ) as PublicClientApplication;
      setMsalInstance(msalInstance);
      const instance = msalInstance as PublicClientApplication;
      instance.initialize().then(() => {
        // Account selection logic is app dependent. Adjust as needed for different use cases.
        const accounts = instance.getAllAccounts();
        if (accounts && accounts.length > 0) {
          instance.setActiveAccount(accounts[0]);
        }

        instance.addEventCallback((event: EventMessage) => {
          if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const payload = event.payload as AuthenticationResult;
            const account = payload.account;
            instance.setActiveAccount(account);
          }
        });

        ReactDOM.render(
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <ConnectedRouter history={history}>
                <App msal={msalInstance} identityMgrType={identityMgrType} />
              </ConnectedRouter>
            </PersistGate>
          </Provider>,
          document.getElementById('root')
        );
      });
    } else if (Config.IdentityManagerType === IdentityManagerType.Auth0) {
      ReactDOM.render(
        <Provider store={store}>
          <PersistGate loading={undefined} persistor={persistor}>
            <ConnectedRouter history={history}>
              <App
                auth0={Config.Configuration.auth}
                identityMgrType={identityMgrType}
              />
            </ConnectedRouter>
          </PersistGate>
        </Provider>,
        document.getElementById('root')
      );
    }
  }
});
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
